import { render, staticRenderFns } from "./feedback-item.vue?vue&type=template&id=c7fccf9c"
import script from "./feedback-item.vue?vue&type=script&lang=js"
export * from "./feedback-item.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports